<template>
  <el-dialog title="复制认证规则"
             :close-on-click-modal="false"
             :show-close="true"
             :visible.sync="visible"
             width="500px"
             :before-close="dialogClose">
    <el-card shadow="never"
             class="aui-card--fill">
    <el-form label-width="auto"
             label-position="left"
             :model="dataForm">
      <el-row class="margb10">
        <el-col :span="24">
          <el-form-item>
            <div id="container">
              <span style="float: left;margin-top:5px;">{{ $t('cert.copyFont') }}&nbsp;&nbsp;</span>
              <div class="box01" style="width: 100px; float: left;">
                <el-select v-model="dataForm.yearFrom"
                          :placeholder="$t('cert.select')"
                          style="width:100px;">
                  <el-option v-for="(item,index) in yearFromArrs"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </div>
              <span style="float: left;margin-top:5px;">&nbsp;&nbsp;{{ $t('cert.ruleToFont') }}&nbsp;&nbsp;</span>
              <div class="box02" style="width: 100px; float: left;">
                <el-select v-model="dataForm.yearTo"
                           :placeholder="$t('cert.select')"
                           style="width:100px;">
                  <el-option v-for="(item,index) in yearToArrs"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <el-col :span="24">
          <span style="color:red;">*&nbsp;</span>{{ $t('cert.ruleCopyNotice') }}
        </el-col>
      </el-row>
      <el-row style="margin-top:50px;" class="margb10">
        <el-col :span="17">&nbsp;</el-col>
        <el-col :span="7">
          <el-button type="primary" class="M-search" @click="submitCopyCert" :loading="loading">{{ $t('cert.confirm') }}</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      title="复制认证未成功，错误信息如下"
      :close-on-click-modal="false"
      :visible.sync="hasError"
      append-to-body
      width="500px">
      <el-table :data="errorList"
                border
                style="width: 100%;">
        <el-table-column type="index"
                         :index="indexMethod"
                         label="No"
                         header-align="center"
                         align="center"
                         width="50">
        </el-table-column>
        <el-table-column prop="errCode"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         v-if="false"
                         :label="$t('cert.certCode')">
        </el-table-column>
        <el-table-column prop="yearFrom"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         v-if="false"
                         :label="$t('cert.certCode')">
        </el-table-column>
        <el-table-column prop="yearTo"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         v-if="false"
                         :label="$t('cert.certCode')">
        </el-table-column>
        <el-table-column prop="certCode"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('cert.certCode')">
        </el-table-column>
        <el-table-column prop="message"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :formatter="errMessageFormatter"
                         :label="$t('cert.message')">
        </el-table-column>
      </el-table>
    </el-dialog>
    </el-card>
  </el-dialog>
</template>

<script>
export default {
  name: 'copyCertRule',
  data () {
    return {
      loading: false,
      yearFromArrs: [],
      yearToArrs: [],
      hasError: false,
      errorList: [],
      dataForm: {
        yearFrom: '',
        yearTo: ''
      },
      dataFormHold: {
        yearFromArr: [],
        yearToArr: []
      }
    }
  },
  props: {
    visible: {// 是否显示
      type: Boolean,
      required: false,
      default: false
    },
    certIdList: {// 认证规则ID
      type: Array,
      required: true
    }
  },
  methods: {
    initMethods () {
      this.dataForm = {
        yearFrom: '',
        yearTo: ''
      }
      this.dataFormHold = {
        yearFromArr: [],
        yearToArr: []
      }
      this.yearFromArrs = []
      this.yearToArrs = []
      var nowDate = new Date()
      var nowYear = nowDate.getFullYear()
      console.log(nowYear)
      
      for (var i = 2019; i <= nowYear; i++) {
        let yearFrom = {
          name: i,
          code: i
        }
        this.yearFromArrs.push(yearFrom)
        console.log(this.yearFromArrs)
      }
      // var yearCount = this.enums['certCopyCount'][0].code
      var yearCount = this.enums['certyearCount'][0].code
      console.log(yearCount)
      for (var j = nowYear + 1; j <= nowYear + parseInt(yearCount, 10); j++) {
        let yearTo = {
          name: j,
          code: j
        }
        this.yearToArrs.push(yearTo)
      }
    },
    indexMethod (index) {
      return index + 1
    },
    init () {
      this.visible = true
      this.loading = false
    },
    dialogClose (done) {
      this.$emit('closeDialogCopyCert')
      done()
    },
    submitCopyCert () {
      let _this = this
      if (_this.dataForm.yearFrom === null || _this.dataForm.yearFrom.length === 0 || _this.dataForm.yearFrom === undefined) {
        _this.$message.warning(_this.$t('cert.pleaseSelectYearFrom'))
        return false
      }
      if (_this.dataForm.yearTo === null || _this.dataForm.yearTo.length === 0 || _this.dataForm.yearTo === undefined) {
        _this.$message.warning(_this.$t('cert.pleaseSelectYearTo'))
        return false
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('cert.copyCert') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        let url = '/learning/certinfo/copyCertRules'
        let param = {
          certIds: this.certIdList.join(','),
          yearFrom: this.dataForm.yearFrom.toString(),
          yearTo: this.dataForm.yearTo.toString()
        }
        this.loading = true
        _this.$request.post(
          url, param
        ).then((res, code, msg, data) => {
          let resultList = data.data
          if (resultList == null || resultList.length === 0) {
            _this.$message({
              message: _this.$t('prompt.success'),
              type: 'success',
              duration: 500
            })
            this.init()
            this.visible = false
            this.$emit('closeDialogCopyCert')
          }
          if (resultList !== null && resultList.length > 0) {
            this.hasError = true
            this.loading = false
            this.errorList = resultList
            return false
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    errMessageFormatter (row) {
      // yearFrom没有
      if (row.errCode === '1001') {
        return this.$t('cert.noCertFrom', { 'yearFrom': row.yearFrom })
      }
      // yearTo存在
      if (row.errCode === '1002') {
        return this.$t('cert.hasCertTo', { 'yearTo': row.yearTo })
      }
      // 该认证规则已下架不能复制
      if (row.errCode === '1003') {
        return this.$t('cert.underStatusCannotCopy')
      }
      // 该认证规则未发布不能复制
      if (row.errCode === '1004') {
        return this.$t('cert.unreleasedStatusCannotCopy')
      }
    }
  }
}
</script>
<style scoped>
  .line {
    height: 1px;
    border-top: 1px solid #b2b0b4;
    text-align: center;
    margin: 10px;
  }
</style>
